import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-turbotax',
  templateUrl: './turbotax.component.html',
  styleUrls: ['./turbotax.component.scss']
})
export class TurbotaxComponent implements OnInit {

  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['turbotax'];
  }

}
